<template>
  <div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="table_data"
    />
    <div class="mt-20 w-full flex items-center justify-end">
      <el-button type="primary" @click="onConfirm">确认</el-button>
      <el-button @click="onCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { clone } from '@/utils';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    // 选中的表格项
    tableRows: {
      type: Array,
      required: true,
    },
    // 表格数据
    dataSources: {
      type: Array,
      required: true,
    },
    // 表单分配的数据列表
    formAssignData: {
      type: Object,
      required: true,
    },
    // 落地页数量选择限制
    multipleLimit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格数据 */
      table_data: [],
    };
  },
  created() {
    this.table_data = this.getTableData();
  },
  methods: {
    /**
     * 获取表格数据
     * @returns {Object[]}
     */
    getTableData() {
      const table_data = [];
      const { site_config = [] } = this.formAssignData;
      const config = clone(site_config);
      this.tableRows.forEach(row => {
        const is_repeat = table_data.some(({ campaign_name }) => campaign_name === row.campaign.campaign_name);
        if (!is_repeat) {
          table_data.push({
            advertiser_id: row.advertiser_id,
            campaign_name: row.campaign.campaign_name,
            sites: {
              options: config.filter(({ advertiser_id }) => String(advertiser_id) === String(row.advertiser_id)),
              value: [],
            },
          });
        }
      });

      return table_data;
    },
    /** 确认 */
    onConfirm() {
      const is_valid = this.table_data.every(({ sites }) => sites.options.length === 0 || (sites.options.length && sites.value.length));
      if (!is_valid) {
        this.$message.warning('请完整分配落地页');
        return;
      }
      this.dataSources.forEach(item => {
        const match_item = this.table_data.find(({ campaign_name }) => item.campaign.campaign_name === campaign_name);
        if (match_item) {
          const { sites: { value = [] } = {}} = match_item;
          if (value.length) {
            value.forEach(site => delete site.advertiser_id);
            Object.assign(item.creative, { sites: value });
          }
        }
      });
      this.$message.success('编辑成功');
      this.$emit('confirm');
    },
    /** 取消 */
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
